<div class="container-fluid" style="padding-left: 0px; padding-right: 0px;">
  <router-outlet></router-outlet>
</div>
